export function formatMarkerCount(userCount, totalCount) {
  return userCount !== undefined ? `${userCount} / ${totalCount}` : totalCount;
}

export function getReportListCardVariantStyles(variant) {
  if (variant === "disabled") {
    return {
      bg: "lightGrey",
      color: "midGrey",
      cursor: "default",
      showMarkers: false
    };
  }

  return {
    bg: "white",
    color: "dark",
    cursor: "pointer",
    showMarkers: true
  };
}
